import React, { useEffect, useState } from 'react';
import { 
    Container, Button, TextField, 
    Table, TableBody, TableCell, TableHead, TableRow, Paper, Box,
    useMediaQuery
} from '@material-ui/core';
import { db } from '../firebase';
import { useTheme } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';

const PER_PAGE = 5;

// Fungsi aman untuk mengubah berbagai format tanggal/timestamp menjadi string
const formatDate = (dateObj) => {
    if (!dateObj) return '-';
    if (typeof dateObj === 'string') return dateObj;
    
    try {
        let d = new Date(dateObj.seconds ? dateObj.seconds * 1000 : dateObj);
        if (isNaN(d.getTime())) return String(dateObj);
        
        return d.toLocaleString('id-ID', {
            timeZone: 'Asia/Jakarta',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    } catch (e) {
        return '-';
    }
};

const Iot = () => {
    // Menangkap parameter dari URL: /iot/:datetime/:locate
    const { datetime: urlDatetime, locate: urlLocate } = useParams();
    
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // Hanya melakukan submit ke Firebase jika parameter URL lengkap
    useEffect(() => {
        if (urlDatetime && urlLocate) {
            db.collection("iot").doc()
                .set({
                    lokasi: urlLocate,
                    datetime: urlDatetime,
                    created_at: new Date()
                })
                .then(() => {
                    console.log("Data dari URL berhasil dikirim ke Firebase!");
                })
                .catch(err => {
                    console.error("Gagal mengirim data dari URL: ", err);
                });
        }
    }, [urlDatetime, urlLocate]);

    useEffect(() => {
        // Mengambil data secara real-time dari koleksi 'iot'
        // Diurutkan secara ascending (asc) berdasarkan created_at
        const unsubscribe = db.collection('iot')
            .orderBy('created_at', 'asc')
            .onSnapshot(snapshot => {
                try {
                    const iotDataList = snapshot.docs.map(doc => {
                        const docData = doc.data() || {};
                        return {
                            id: doc.id,
                            lokasi: docData.lokasi || '-',
                            datetime: docData.datetime ? formatDate(docData.datetime) : formatDate(docData.created_at)
                        };
                    });
                    setData(iotDataList);
                } catch (err) {
                    console.error("Gagal memproses data snapshot:", err);
                } finally {
                    setLoading(false);
                }
            }, (error) => {
                console.error("Error mengambil data IoT:", error);
                setLoading(false);
            });
        return () => unsubscribe();
    }, []);

    // Filter data berdasarkan lokasi secara aman
    const filteredData = Array.isArray(data) 
        ? data.filter(item => item.lokasi && String(item.lokasi).toLowerCase().includes(search.toLowerCase())) 
        : [];
    
    const maxPage = Math.ceil(filteredData.length / PER_PAGE);
    const currentData = Array.isArray(filteredData) 
        ? filteredData.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE) 
        : [];

    return (
        <Container maxWidth="md">
            <h1 style={{ fontSize: isMobile ? '1.5rem' : '2rem', textAlign: isMobile ? 'center' : 'left' }}>
                History Food Feeder
            </h1>
            
            <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={2} alignItems={isMobile ? 'stretch' : 'center'}>
                <TextField 
                    label="Cari Berdasarkan Lokasi" 
                    value={search} 
                    onChange={e => { setSearch(e.target.value); setCurrentPage(1); }} 
                    fullWidth 
                    margin="normal"
                />
            </Box>

            {/* Tabel Data IoT */}
            <Paper style={{ marginTop: 20, overflowX: 'auto', height: 300 }}>
                <Table stickyHeader size={isMobile ? "small" : "medium"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>No.</TableCell>
                            <TableCell>Lokasi</TableCell>
                            <TableCell>Timestamps</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow><TableCell colSpan={3} align="center">Loading...</TableCell></TableRow>
                        ) : currentData.length === 0 ? (
                            <TableRow><TableCell colSpan={3} align="center">Tidak ada data</TableCell></TableRow>
                        ) : (
                            currentData.map((item, index) => (
                                <TableRow key={item.id} hover>
                                    <TableCell>{(currentPage - 1) * PER_PAGE + index + 1}</TableCell>
                                    <TableCell>{item.lokasi}</TableCell>
                                    <TableCell>{item.datetime}</TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </Paper>

            {/* Navigasi Pagination */}
            <Box display="flex" justifyContent="center" flexWrap="wrap" marginTop={2} gap={1}>
                <Button 
                    disabled={currentPage === 1} 
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    Prev
                </Button>
                
                {[...Array(maxPage)].map((_, i) => (
                    <Button 
                        key={i + 1} 
                        variant={currentPage === i + 1 ? "contained" : "outlined"} 
                        onClick={() => setCurrentPage(i + 1)} 
                        size={isMobile ? "small" : "medium"}
                    >
                        {i + 1}
                    </Button>
                ))}
                
                <Button 
                    disabled={currentPage === maxPage || maxPage === 0} 
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    Next
                </Button>
            </Box>
        </Container>
    );
};

export default Iot;